const ahuProperties = [
  {
    name: "AHU Profile",
    value: "AHUProfile",
    info: {
      propKey: "AHUProfile",
      description:
        "section includes general information about the Air Handler Unit, such as equipment name, serial number, model number, and sales order number.",
      imageSrc: "/images/ahupr/ahu-profile-img.png",
      dialogWidth: "992px",
      imageWidth: "925px",
      imageHeight: "156px"
    }
  },
  {
    name: "Unit Configuration",
    value: "UnitConfiguration",
    info: {
      propKey: "UnitConfiguration",
      description: "section provides details of the AHU’s configuration.",
      imageSrc: "/images/ahupr/unit-configuration-img.png",
      dialogWidth: "781px",
      imageWidth: "781px",
      imageHeight: "320px"
    }
  },
  {
    name: "Operational Data",
    value: "OperationalData",
    info: {
      propKey: "OperationalData",
      description:
        "section provides a unit-level view of the AHU’s operation during the report period. It also includes a separate view of the unit’s operation segregated by Heat/Cool Mode.",
      imageSrc: "/images/ahupr/operational-data-img.png",
      dialogWidth: "992px",
      imageWidth: "925px",
      imageHeight: "320px"
    }
  },
  {
    name: "Circuit Operational Data",
    value: "CircuitOperationalData",
    info: {
      propKey: "CircuitOperationalData",
      preSectionNameText: "On DX AHUs, the",
      description:
        "section provides a summary view of each refrigerant circuit’s operation during the report period.",
      imageSrc: "/images/ahupr/circuit-operational-data-img.png",
      dialogWidth: "781px",
      imageWidth: "713px",
      imageHeight: "320px"
    }
  },
  {
    name: "Compressor Operational Data",
    value: "CompressorOperationalData",
    info: {
      propKey: "CompressorOperationalData",
      preSectionNameText: "On DX AHUs, the",
      description:
        "section provides a summary view of each compressor’s operation during the report period.",
      imageSrc: "/images/ahupr/compressor-operational-data-img.png",
      dialogWidth: "781px",
      imageWidth: "713px",
      imageHeight: "320px"
    }
  },
  {
    name: "Performance Charts",
    value: "PerformanceCharts",
    info: {
      propKey: "PerformanceCharts",
      description:
        "section includes a bar chart that bins Outdoor Air Temperature values observed during the report period along the X Axis. The Left Y Axis displays the proportion of time (in Percent of Time) each Outdoor Air Temperature bin was observed. The Right Y Axis displays the average Cool Output % observed during each Outdoor Air Temperature bin.",
      imageSrc: "/images/ahupr/performance-charts-img.png",
      dialogWidth: "781px",
      imageWidth: "713px",
      imageHeight: "320px"
    }
  }
]

export const getAHUProperties = (isDXCoolType: boolean) => {
  const sectionsForType = isDXCoolType
    ? ahuProperties
    : ahuProperties.filter(
        (prop) =>
          prop.value !== "CircuitOperationalData" &&
          prop.value !== "CompressorOperationalData"
      )
  return {
    finalProps: sectionsForType,
    defaultSelectedProperties: sectionsForType.map((obj) => obj?.value)
  }
}

